type Id = string | number;

export const LicensesRoutes = {
  landing: '/tu-arsat',
  licenses: '/tu-arsat/licencias',
  licenseById: '/tu-arsat/licencias/detalle/',
  licenseByIdMyTeam: '/equipo/licencias/detalle/',
  listLicenses: '/equipo/licencias/listado',
  schedulerLicenses: '/equipo/licencias/cronograma',
  vacation: '/tu-arsat/licencias/vacaciones',
  procedure: '/tu-arsat/licencias/motivos-personales',
  exam: '/tu-arsat/licencias/examen',
  medical: '/tu-arsat/licencias/enfermedad',
  RequestGenerated: '/tu-arsat/licencias/solicitud-generada/',
  othersDefault: 'https://portal.arsat.com.ar/paginas/11-otras-licencias',

  getDetalleById: (idLicense: Id) => `/tu-arsat/licencias/detalle/${idLicense}`,
} as const;
